import { render, staticRenderFns } from "./schoolmanage.vue?vue&type=template&id=e7f03c42&scoped=true&"
import script from "./schoolmanage.vue?vue&type=script&lang=js&"
export * from "./schoolmanage.vue?vue&type=script&lang=js&"
import style0 from "./schoolmanage.vue?vue&type=style&index=0&id=e7f03c42&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7f03c42",
  null
  
)

export default component.exports